import { makeStyles } from '@material-ui/core/styles'
import transitions from '@material-ui/core/styles/transitions'

const useStyles = makeStyles(
	theme => ({
		root: {
			position: 'initial !important',

			[theme.breakpoints.down('sm')]: {
				marginRight: theme.spacing(-3),
				marginLeft: theme.spacing(-3),
			},
		},
		mobileBackground: {
			position: 'absolute',
			top: 0,
			left: 0,
			right: 0,
			bottom: 0,

			'&:after': {
				content: '""',
				transition: theme.transitions.create('opacity'),
				backgroundColor: 'black',
				width: '100%',
				height: '100%',
				position: 'absolute',
				top: 0,
				left: 0,
				opacity: ({ metaData }) => (metaData.mobileOpacity?.toNumber() || 0) / 100,
			},
		},
		bgSection: {
			position: 'absolute !important',
			height: '100%',
			left: 0,
			right: 0,
			top: 0,
			bottom: 0,
			overflow: 'hidden',
			zIndex: 1,
			transition: transitions.create(['left', 'right']),

			[theme.breakpoints.down('sm')]: {
				height: 'auto',
				position: 'relative !important',
				left: '0 !important',
				right: '0 !important',
				'& + $content': {
					marginTop: theme.spacing(4),
				},
			},
		},
		content: {
			[theme.breakpoints.down('sm')]: {
				'& + $bgSection': {
					marginTop: theme.spacing(4),
				},
			},
		},

		background: {
			height: theme.spacing(30.5),
			width: '100%',
			overflow: 'hidden',
			[theme.breakpoints.up('md')]: {
				height: '100%',
			},
		},

		textWrap: {
			position: 'relative',
			zIndex: 2,
			[theme.breakpoints.down('sm')]: {
				paddingLeft: theme.spacing(3),
				paddingRight: theme.spacing(3),
			},
		},
		text: {
			[theme.breakpoints.down('sm')]: {
				'& *': {
					textAlign: ({ metaData }) => {
						const mobileAlignment = metaData.mobileAlignment?.metaValue

						return mobileAlignment ? `${mobileAlignment} !important` : null
					},
				},
			},
		},
	}),
	{ name: 'Content-Content6' },
)

export default useStyles
